import { render, staticRenderFns } from "./CoralstoneUnitNavbar.vue?vue&type=template&id=87ad3b12&scoped=true&"
import script from "./CoralstoneUnitNavbar.vue?vue&type=script&lang=js&"
export * from "./CoralstoneUnitNavbar.vue?vue&type=script&lang=js&"
import style0 from "./CoralstoneUnitNavbar.vue?vue&type=style&index=0&id=87ad3b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ad3b12",
  null
  
)

export default component.exports